import { isAccountFeatureEnabled } from "owa-feature-flags";
import { getStore } from "owa-protection-store/lib/store/protectionStore";
import isConsumer from "owa-session-store/lib/utils/isConsumer";
import type { MailboxInfo } from "owa-client-types";

export default function isCLPEnabled(mailboxInfo: MailboxInfo): boolean {
    const protectionStore = getStore(mailboxInfo);
    const { clpLabels } = protectionStore;
    return (isAccountFeatureEnabled("cmp-clp", mailboxInfo, !!mailboxInfo /* dontThrowErrorIfNotInitialized to help visually identify the scenarios hitting the error */) &&
        clpLabels.some(label => (!label.children?.length && label.isLabelEnabled) ||
            label.children?.some(childLabel => childLabel.isLabelEnabled)) &&
        !isConsumer(undefined /* smtpAddress */, mailboxInfo));
}
